export default __webpack_public_path__ + "static/media/check.bd752334.svg";